import { useQuery } from '@tanstack/react-query'

import { caaMetricsInstance } from '../..'

export function getOperationalCAAMetricsTherapistYearQueryKey({
  personaName,
  year
}: {
  personaName?: string
  year: number
}) {
  return ['operationalCAAMetricsTherapistYear', { personaName, year }]
}

export function useOperationalCAAMetricsTherapistYearQuery({
  personaName,
  year,
  enabled
}: {
  personaName?: string
  year: number
  enabled?: boolean
}) {
  return useQuery({
    queryKey: getOperationalCAAMetricsTherapistYearQueryKey({
      personaName,
      year
    }),
    queryFn: async () =>
      await caaMetricsInstance.getOperationalCAAMetricsTherapistYear({
        personaName,
        year
      }),
    enabled
  })
}
